
const index = () => import('../../views/home/index.vue');
const shengtai = () => import('../../views/shengtai/index.vue');
const gaoduan = () => import('../../views/shengtai/gaoduan.vue');
const chuangyi = () => import('../../views/shengtai/chuangyi.vue');
const shiti = () => import('../../views/shengtai/shiti.vue');
export default [ {
    path: '/index',
    name: 'index',
    component: index,
    children:[{
        path: '/shengtai',
        name: 'shengtai',
        component: shengtai,
    },{
        path: '/gaoduan',
        name: 'gaoduan',
        component: gaoduan,
    },{
        path: '/chuangyi',
        name: 'chuangyi',
        component: chuangyi,
    },{
        path: '/shiti',
        name: 'shiti',
        component: shiti,
    }]
}
];
